//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { SimulationRequest } from './models/SimulationRequest';
import type { SimulationRequestPaginationResult } from './models/SimulationRequestPaginationResult';
import type { SimulationResponse } from './models/SimulationResponse';
import { Utilities } from './Utilities';

export class SimulationsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getSimulation: (
			siren: string,
        ): string => {
            let clientRequestUrl = '/api/v1/simulations/{siren}/do-get-simulation';
            if (siren === undefined || siren === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('siren'));
            }
            clientRequestUrl = clientRequestUrl.replace('{siren}', encodeURIComponent(String(siren)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getSavedSimulations: (): string => {
            let clientRequestUrl = '/api/v1/simulations';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get simulation
     * @param body (optional) 
     * @return OK
     */
    async getSimulation(
        siren: string,
        body?: SimulationRequest,
    ): Promise<SimulationResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getSimulation(
            siren,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SimulationResponse>(_response, false, []);
    }

    /**
     * Get saved simulations
     * @return OK
     */
    async getSavedSimulations(): Promise<SimulationRequestPaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getSavedSimulations();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SimulationRequestPaginationResult>(_response, false, []);
    }
}
